export const handleCopy = (text, setCopyText) => () => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('Copy');
    document.body.removeChild(textarea);
    setCopyText('Copied');
    setTimeout(() => setCopyText('Copy'), 1000);
  };
  